import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppState} from "../../store";
import {Store} from "@ngrx/store";
import {
  getFilterByKey, getFilteredJobsNumber,
  getFilteredProfessionsNumber,
  getFilteredProvidersNumber,
  getFilteredRookieNumber
} from "../../store/selectors/filter.selector";
import {Overlayable} from "../../interfaces/overlayable";
import {resetFilterByKey, resetFiltersByEntity, setUpdateArchiveView} from "../../store/actions/filter.actions";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-search-filter-footer',
  templateUrl: './search-filter-footer.component.html',
  styleUrls: ['./search-filter-footer.component.scss']
})
export class SearchFilterFooterComponent implements Overlayable, OnInit{

  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @ViewChild('saveButtonWrapper') saveButtonWrapper!: ElementRef<HTMLElement>;
  @Input('filterKey') set setFilterKey(val: string) {
    this.filterKey = val;
    this.isEntityKey = this.filterKey === "allProfession" || this.filterKey === "allProvider" || this.filterKey === "allJob" || this.filterKey === "allRookie";
  };
  @Input('entityType') set setEntityType(val: "allProfession" | "allProvider" | "allJob" | "allRookie") {
    if(val.length) {
      this.entityType = val;
      if(this.entityType === "allProfession") {
        this.store.select(getFilteredProfessionsNumber()).pipe(untilDestroyed(this)).subscribe((newVal) => {
          this.filteredProfessionsNumber = newVal;
        });
      } else if(this.entityType === "allProvider") {
        this.store.select(getFilteredProvidersNumber()).pipe(untilDestroyed(this)).subscribe((newVal) => {
          this.filteredProfessionsNumber = newVal;
        });
      } else if(this.entityType === "allJob") {
        this.store.select(getFilteredJobsNumber()).pipe(untilDestroyed(this)).subscribe((newVal) => {
          this.filteredProfessionsNumber = newVal;
        });
      } else if(this.entityType === "allRookie") {
        this.store.select(getFilteredRookieNumber()).pipe(untilDestroyed(this)).subscribe((newVal) => {
          this.filteredProfessionsNumber = newVal;
        });
      }
    }
  }
  // whether can delete ALL filters for entity or all items from SINGLE FILTER
  @Input('isEntityFooter') isEntityFooter = false;
  filterKey: string = "";
  filteredProfessionsNumber = 0;
  activeItemsByKey = 0;
  isLoadingOnClose = false;
  changesHappened = false;
  entityType: "allProfession" | "allProvider" | "allJob" | "allRookie" | "" = "";
  isEntityKey = false;
  constructor(private store: Store<AppState>) {
  }

  ngOnInit() {
    let isFirstCall = true;
    if(this.isEntityFooter && this.entityType.length) {
      this.store.select(getFilterByKey(this.entityType)).pipe(untilDestroyed(this)).subscribe((newVal) => {

        let totalItems = 0;

        for(let key in newVal) {
          if(typeof newVal[key] !== "object") {
            if(newVal[key]) {
              totalItems++;
            }
          } else {
            totalItems+= newVal[key].length;
          }
        }
        this.activeItemsByKey = totalItems;
        // this.activeItemsByKey = newVal.length;

        if(!isFirstCall) {
          this.changesHappened = true;
        }
        isFirstCall = false;
      })
    } else {
      this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe((newVal) => {
        this.activeItemsByKey = newVal.length;

        if(!isFirstCall) {
          this.changesHappened = true;
        }
        isFirstCall = false;
      })
    }

  }

  resetFilterByKey() {
    if(this.isEntityFooter && this.entityType !== "") {
      this.store.dispatch(resetFiltersByEntity({key: this.entityType}));
    } else {
      this.store.dispatch(resetFilterByKey({key: this.filterKey}));
    }

    (this.saveButtonWrapper.nativeElement.querySelector("button, a") as HTMLElement).focus();
  }

  getButtonLabel() {

    if(this.entityType === "") {
      return "Filter anwenden";
    } else {
      let entityName = "";
      if(this.entityType === "allProfession") entityName = "Berufe";
      else if(this.entityType === "allProvider") entityName = "Anbieter";
      else if(this.entityType === "allJob") entityName = "Jobs";
      else if(this.entityType === "allRookie") entityName = "Schnupperplätze";

      return this.filteredProfessionsNumber + ' ' + entityName + ' anzeigen';
    }


  }

  onSaveClicked() {
    if(this.changesHappened) {
      if(!this.isLoadingOnClose) {
        this.store.dispatch(setUpdateArchiveView({updateActive: true}));
        this.isLoadingOnClose = true;
        setTimeout(() => {
          this.onClosed.emit(true);
        }, 600); // audit time of requests
      }
    } else {
      this.onClosed.emit(true);
    }

  }
}
